import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,  faChartLine,faClipboardList,faStream,faCalendar,faCog
} from '@fortawesome/free-solid-svg-icons';
import './Sidebar.css';

const Sidebar = ({ collapsed, toggleSidebar }) => {


  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className={`logo-container ${collapsed ? 'collapsed' : ''}`}>
        <span className="logo">WhizBang</span>
        <button className="toggle-btn" onClick={toggleSidebar}>
          <FontAwesomeIcon icon={faBars} />
        </button>
      </div>
      <ul>
        <li>
          <Link to="/usermanagement" title="usermanagement">
            <FontAwesomeIcon icon={faChartLine} className="fa-icon" /> 
            <span className="link-text">Home</span>
          </Link>
        </li>
        <li>
          <Link to="/message" title="Message">
            <FontAwesomeIcon icon={faStream} className="fa-icon" /> 
            <span className="link-text">Message</span>
          </Link>
        </li>
        <li>
          <Link to="/template" title="template">
            <FontAwesomeIcon icon={faClipboardList} className="fa-icon" /> 
            <span className="link-text">Template</span>
          </Link>
        </li>
        <li>
          <Link to="/memberManagement" title="MemberManagement">
            <FontAwesomeIcon icon={faCalendar} className="fa-icon" /> 
            <span style={{fontSize:'12px'}} className="link-text"> Member Management</span>
          </Link>
        </li>
        <li>
          <Link to="/marketing" title="campigion">
            <FontAwesomeIcon icon={faCog} className="fa-icon" /> 
            <span className="link-text">Campigion</span>
          </Link>
        </li>
        {/* <li>
          <Link to="/utilities" title="Utilities">
            <FontAwesomeIcon icon={faCog} className="fa-icon" /> 
            <span className="link-text">Utilities</span>
          </Link>
        </li> */}
        {/* <li>
          <Link to="/settings" title="Settings">
            <FontAwesomeIcon icon={faCog} className="fa-icon" /> 
            <span className="link-text">Settings</span>
          </Link>
        </li> */}
        {/* <li>
          <Link to="/hospital/:id">
            <FontAwesomeIcon icon={faFileMedicalAlt} className="fa-icon" /> 
            <span className="link-text">Pre-Consultation</span>
          </Link>
        </li> */}
      </ul>
    </div>
  );
};

export default Sidebar;
